export const urlToNumber = (urlPart: string | null, defaultValue: number): number => {
    const unsafeNumber = urlPart === null ? defaultValue : Number(urlPart);
    const safeNumber = isNaN(unsafeNumber) ? defaultValue : unsafeNumber;
    return safeNumber;
};

export const urlToString = (urlPart: string | null, defaultValue: string): string => {
    return urlPart ?? defaultValue;
};
